// extracted by mini-css-extract-plugin
export default {"limit":"Header_limit__PXeg8","logo":"Header_logo__8s1uk","name":"Header_name__sjC-l","infoPanel":"Header_infoPanel__9E8bu","userID":"Header_userID__PH6oJ"};